const BrowserErrorReporter = (e: ErrorEvent) => {
  try {
    const token = sessionStorage.getItem('ZervantSession')
    let error
    if (e.error) {
      error = {
        message: e.error.message,
        stack: e.error.stack,
      }
    } else {
      error = {
        message: e.message,
      }
    }
    let userInfo = {}
    if (token) {
      const user = JSON.parse(atob(token.split('.')[1]))
      userInfo = {
        company: user['custom:companyId'],
        country: user['custom:country'],
        language: user['custom:language'],
        email: user.email,
      }
    } else {
      userInfo = {
        language: navigator.language.split('-')[0],
        country: navigator.language.split('-')[1],
      }
    }

    fetch('/spoe/api/v1/logs', {
      method: 'put',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        error,
        userInfo,
        userAgent: navigator.userAgent,
        state: {
          href: window.location.href,
          ZervantState: sessionStorage.getItem('ZervantState'),
        },
      }),
    })
  } catch (e) {
    // We dont really care for this error as there is nothing we can do about it
  }
}

export default BrowserErrorReporter
